
import { PaymentService } from './../payment-service/payment-service';
import { MyGolfStorageService } from './../../storage/mygolf-storage.service';
import { CompetitionService } from './../../providers/competition-service/competition-service';
import { ClubMembership, ColorOrderPaymentStatus, ColorOrderStatus, ColorTeeTimeBookingStatus, createLocalOrder, DiscountCompany, Order, OrderExtended, PaymentGatewayInfo } from './../../data/mygolf.data';
import { ClubInfo } from './../../data/club-course';
import { Injectable } from '@angular/core';
import { JsonService } from './../json-util';
import { ClubFlightService } from './../providers/club-flight-service/club-flight-service';
import * as globals from '../../globals';
import { LoadingController, Platform } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class OrderService {

    appAttribute: any;
    appAttributes: Array<any>;
    isClubSpecific: boolean;
    selClubMembership;
    homeClub: ClubInfo;
    clubId: number;
    settingsAttribute: any;

    playerClubMembership: Array<ClubMembership>;

    selectedClub: any;
    isWebParam: boolean;
    enableMGA: boolean = false;
    enableMakePaymentToClub: boolean = false;
    localOrder: OrderExtended;
    needRefreshOrderDetails: BehaviorSubject<boolean> = new BehaviorSubject(false);
    constructor(
        private platform: Platform,
        private compService: CompetitionService,
        private storage: MyGolfStorageService,
        private paymentService: PaymentService,
        private loadingCtrl: LoadingController
        // private flightService: ClubFlightService
        ) {
        let _param = this.platform.getQueryParam('param');
        if(globals.appType === 'main' && globals.clubId && !_param)
            this.clubId = globals.clubId
        this.enableMGA = (this.platform.getQueryParam('enableMGA') === 'true');
        this.enableMakePaymentToClub = (this.platform.getQueryParam('enableMakePaymentToClub') === 'true');
        this.localOrder = createLocalOrder();
        // this.cartId = this.storage.getPreference('cartId');
        this.setCartId();
        this.setOrderDetails(null);
    }
    public numberWithCommas(x: any) {
        // if(!x) return;
        // x = Number(x);
        // x = Number(x.toFixed(2));
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    public getUnique(arr, comp) {

        // store the comparison  values in array
        const unique = arr.map(e => e[comp])

            // store the indexes of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)

            // eliminate the false indexes & return unique objects
            .filter((e) => arr[e]).map(e => arr[e]);

        return unique;
    }

    // public getAppAttribute(page: string) {
    //     if(!page) return;
    //     this.flightService.getAppAttributes()
    //         .subscribe((data: any) => {
    //             console.log("[app attribute] : ", data)
    //             if (data) {
    //                 data.filter((d) => {
    //                     return d.page === page
    //                 }).map((d) => {
    //                     this.appAttribute = d
    //                 });
    //                 console.log("[app attribute] : ", this.appAttribute);
    //             }
    //         })
    // }

    public setClubSpecific(clubSpecific: boolean) {
        this.isClubSpecific = clubSpecific;
    }

    public getClubSpecific() {
        return this.isClubSpecific;
    }

    public setAppAttributes(appAttributes) {
        this.appAttributes = appAttributes;
    }

    public getAppAttribute() {
        return this.appAttributes;
    }

    public setClubMembership(selClubMembership) {
        this.selClubMembership = selClubMembership;
    }

    public getClubMembership() {
        return this.selClubMembership;
    }

    public setHomeClub(club) {
        this.homeClub = club;
    }
    public getHomeClub(): ClubInfo {
        return this.homeClub;
    }
    public getClubSpecificHeader(attribute):any {
        // console.debug("#################### start #####################");
        // console.debug("util : attribute", attribute);
        // console.debug("util : selclubmembership", this.selClubMembership);
        // console.debug("util : appAttributes", this.appAttributes);
        // console.debug("util : is web param : ", this.isWebParam);
        // console.debug("util : selected club : ", this.selectedClub);
        // console.debug("util : club id : ", this.clubId);
        // console.debug('####################### end ########################')
        // console.debug("util : ", this.selClubMembership);
        if(!attribute) return;
        if(!this.selClubMembership && !this.isWebParam) return;
        let _clubSpecific = {
            headerLogo: '',
            headerTitle: '',
            enableHeaderLogo: false,
            enableHeaderTitle: false,
            clubId: null
        };
        if(!this.isWebParam || this.selClubMembership)
            this.appAttributes.filter((appAtt)=>{
                return appAtt.page === 'playerHome'
            }).map((appAtt)=>{
                appAtt.clubSpecificThemes.filter((cc)=>{
                    return this.selClubMembership.club.clubId === cc.clubId;
                }).map((cc)=>{
                    _clubSpecific = cc;
                });

            })
        // else if(this.isWebParam && this.selectedClub) {
        //     this.appAttributes.filter((appAtt)=>{
        //         return appAtt.page === 'playerHome'
        //     }).map((appAtt)=>{
        //         appAtt.clubSpecificThemes.filter((cc)=>{
        //             return this.selectedClub.id === cc.clubId;
        //         }).map((cc)=>{
        //             _clubSpecific = cc;
        //         });

        //     })
        // }
        else if(this.isWebParam) {
            if(!this.selectedClub && this.clubId && this.appAttributes) {
              // console.debug("util selected club no : ", this.selectedClub, _clubSpecific)
                // (!_clubSpecific.clubId) &&
                //// console.debug("util inside : ", this.selectedClub, this.clubId, _clubSpecific, this.appAttributes);
                this.appAttributes.filter((appAtt)=>{
                    return appAtt.page === 'playerHome'
                }).map((appAtt)=>{
                    // console.debug("util inside : ", appAtt.clubSpecificThemes)
                    appAtt.clubSpecificThemes.filter((cc)=>{
                        return this.clubId === cc.clubId;
                    }).map((cc)=>{
                        _clubSpecific = cc;
                    });

                })
            }
            else if(this.selectedClub) {
              // console.debug("util selected club yes : ", this.selectedClub, _clubSpecific)
                // !_clubSpecific.clubId) &&
                if(this.selectedClub.clubLogo)
                    _clubSpecific['headerLogo'] = globals.MygolfServer + '/' + this.selectedClub.clubLogo;
                else if(!this.selectedClub.clubLogo && this.selectedClub.clubThumbnail)
                    _clubSpecific['headerLogo'] = globals.MygolfServer + '/' + this.selectedClub.clubLogo;
                else if(!this.selectedClub.clubLogo && !this.selectedClub.clubThumbnail && this.selectedClub.clubImage)
                    _clubSpecific.headerLogo = this.selectedClub.clubImage;
                _clubSpecific['headerTitle'] = this.selectedClub.name?this.selectedClub.name:this.selectedClub.clubName;
                _clubSpecific['enableHeaderLogo'] = true
                _clubSpecific['enableHeaderTitle'] = false
            }

        }
        // setTimeout(() =>{

          // console.debug("util club specific : ", _clubSpecific);
          // console.debug("#################### end #####################");
            switch(attribute) {
                case 'header-logo':
                    // JsonService.deriveFullUrl(_clubSpecific, "headerLogo");
                    let _headerLogo = '';
                    if(this.isWebParam) _headerLogo = _clubSpecific['headerLogo'];
                    else _headerLogo = globals.MygolfServer + '/' + _clubSpecific['headerLogo'];
                  // console.debug("club specific header logo  : ", _clubSpecific);
                    return _headerLogo;
                case 'header-title':
                    return _clubSpecific['headerTitle'];
                case 'enableHeaderLogo':
                    return _clubSpecific['enableHeaderLogo'];
                case 'enableHeaderTitle':
                    return _clubSpecific['enableHeaderTitle'];
                case 'showWalletBalance':
                    return _clubSpecific['showWalletBalance'];
                case 'showCreditBalance':
                    let _showCreditBal: boolean = true;
                    if(_clubSpecific['showCreditBalance'] !== undefined)
                        _showCreditBal = _clubSpecific['showCreditBalance']
                    else if(_clubSpecific['showWalletBalance']===undefined && _clubSpecific['showCreditBalance'] === undefined )
                        _showCreditBal = true;
                    else if(!_clubSpecific['showWalletBalance'] && !_clubSpecific['showCreditBalance']) _showCreditBal = true
                    else _showCreditBal = _clubSpecific['showCreditBalance']
                    return _showCreditBal; // _clubSpecific['showCreditBalance'];
            }
        // }, 1000)
    }

    public getMembershipType(attribute?: string) {
        if(!this.selClubMembership) return 'Membership No.';
        let _membershipType = {};
        this.appAttributes.filter((appAtt)=>{
            return appAtt.page === 'playerHome'
        }).map((appAtt)=>{
            appAtt.membershipTypes.filter((mtype)=>{
                return mtype.id === this.selClubMembership.membershipType
            }).map((mtype)=>{
                _membershipType['id'] = mtype.id;
                if(mtype.id === 'F' || mtype.id === 'T')
                    _membershipType['name'] = 'Membership No.'
                else _membershipType['name'] = mtype.name;
            })
        })
        if(attribute === 'id') return _membershipType['id']
        else return _membershipType['name'];
    }

    public getClubLogo(attribute) {
        if(!this.appAttributes) return;
        if(!this.clubId) return;
        let _clubLogo;
        let _clubBanner;

        this.appAttributes.filter((appAtt)=>{
            return appAtt.page === 'playerHome'
        }).map((appAtt)=>{
            appAtt.clubSpecificThemes.filter((theme)=>{
                return theme.clubId === this.clubId
            }).map((theme)=>{
                // JsonService.deriveFulImageURL(theme, "clubLogo")
                // JsonService.deriveFulImageURL(theme, "bannerLogo")
                _clubLogo = theme.clubLogo;
                _clubBanner = theme.bannerLogo;//clubBanner;
            })
        })

        switch(attribute) {
            case 'logo':
                return _clubLogo;
            case 'banner':
                return _clubBanner;
        }
    }

    public getSettingsAttribute() {
        if(!this.appAttributes) return;
        // console.debug("get settings attribute : ", this.appAttributes)
        let _settingsAttribute;
        this.appAttributes.filter((appAtt)=>{
            return appAtt.page === 'appSettings';
        }).map((appAtt)=>{
            _settingsAttribute = appAtt;
            this.settingsAttribute = appAtt;
        });
        // console.debug("get settings attribute : ", _settingsAttribute)
        return _settingsAttribute;
    }

    public getSpecificAppAttributePage(page: string) {
        if(!page) return;
        if(!this.appAttributes) return;
        let _appAttribute = null;
        this.appAttributes.filter((appAtt)=>{
            return appAtt.page === page
        }).map((appAtt)=>{
            _appAttribute = appAtt;
        })
        if(!_appAttribute) return;
        else return _appAttribute;
    }

    setPlayerClubMembership(playerClubMembership: Array<ClubMembership>) {
        this.playerClubMembership = playerClubMembership;
        // console.debug("mg2u utils : ", playerClubMembership, this.playerClubMembership)
    }

    public getPlayerClubMembership() {
        return this.playerClubMembership;
    }

    setClubId(clubId: number) {
        // window.resizeTo(50, 50);

        // window.resizeBy(1300,450)// = 800;
        this.clubId = clubId;
        if(this.isClubSpecific) this.setCompClubId();
    }

    async setCompClubId() {
        let searchCriteriaComp = this.compService.getSearch();
        searchCriteriaComp.clubId = this.clubId; // this.selClubMembership.club.clubId;
        this.compService.setSearch(searchCriteriaComp);
    }

    public getClubId() {
        return this.clubId;
    }

    setSelectedClub(club: any) {
        this.selectedClub = club;
    }

    getSelectedClub() {
        return this.selectedClub;
    }

    setClubParam(param: boolean) {
        this.isWebParam = param;
    }

    getClubParam() {
        return this.isWebParam;
    }

    getColorBookingStatus(bookingStatus)  {
        if(!bookingStatus) return;
        let _color = 'Black';
        for(let status in ColorTeeTimeBookingStatus) {
            // console.debug("util : ", status, bookingStatus.toUpperCase() )
            if(status === bookingStatus.toUpperCase())
                _color = ColorTeeTimeBookingStatus[status];
        }
        return _color;
    }


    getColorOrderStatus(orderStatus)  {
        if(!orderStatus) return;
        let _color = 'Black';
        for(let status in ColorOrderStatus) {
            // console.debug("util : ", status, bookingStatus.toUpperCase() )
            if(status === orderStatus.toUpperCase())
                _color = ColorOrderStatus[status];
        }
        return _color;
    }

    getColorOrderPaymentStatus(paymentStatus)  {
        if(!paymentStatus) return;
        let _color = 'Black';
        for(let status in ColorOrderPaymentStatus) {
            // console.debug("util : ", status, bookingStatus.toUpperCase() )
            if(status === paymentStatus.toUpperCase())
                _color = ColorOrderPaymentStatus[status];
        }
        return _color;
    }
    groupBy(list, keyGetter) {
        const map = new Map();
        list.forEach((item) => {
             const key = keyGetter(item);
             const collection = map.get(key);
             if (!collection) {
                 map.set(key, [item]);
             } else {
                 collection.push(item);
             }
        });
        return map;
    }

    getMGALogo() {
        let _mgaLogo = globals.MygolfServer + '/document/logo/MGA_logo.png';
        return _mgaLogo;
    }

    isMGAEnable() {
        let _appAttribute = this.getSpecificAppAttributePage('externalNHS');
        if(_appAttribute && _appAttribute.enableMGA !== undefined) this.enableMGA = _appAttribute.enableMGA;
        return this.enableMGA;
    }

    isMakePaymentToClub() {
        let _appAttribute = this.getSpecificAppAttributePage('accountOptions');
        if(_appAttribute && _appAttribute.enableMakePaymentToClub !== undefined) this.enableMakePaymentToClub = _appAttribute.enableMakePaymentToClub;

        return this.enableMakePaymentToClub;
    }

    isBookingOverrideEnable() {
        let _bookingOverrideEnable: boolean = false;
        _bookingOverrideEnable = this.platform.getQueryParam('bookingOverrideEnable')=="true";
        return _bookingOverrideEnable;
    }

    userType: string = null;
    setUserType(type: string) {
      console.debug("setting user type : ", type)
        this.userType = type;
    }

    getUserType() {
    //   console.debug("getting user type : ", this.userType, this.partnerInfo)
        return this.userType;
    }

    partnerInfo: DiscountCompany;
    setPartnerInfo(partner) {
        this.partnerInfo = partner;
    }

    getPartnerInfo() {
        return this.partnerInfo;
    }

    persistClubTheme: any = null;
    setPersistClubTheme(type?: string) {
        if(type === 'communal') this.persistClubTheme = type;
        else if(type) this.persistClubTheme = type;
        else this.persistClubTheme = null;
    }

    isPersistClubTheme() {
        return this.persistClubTheme;
    }

    addToOrder(booking: any, club: any) {
        console.debug("add to order : ", club, booking);
        console.debug("local order : ", this.localOrder);
        if(!booking) return;
        // if(this.localOrder && !this.localOrder.club) this.localOrder.club = club;
        if(this.localOrder && (!this.localOrder.bookings || (this.localOrder.bookings.length === 0))) this.localOrder.club = club;
        this.localOrder.bookings.push(booking);
    }

    getLocalOrder() {
        return this.localOrder;
    }

    resetLocalOrder() {
        this.localOrder = createLocalOrder();
    }

    cartId: string;
    setCartId() {
        return new Promise((resolve, reject) => {
            this.storage.getPreference('cartId')
            .subscribe((a)=>{
                console.log("get/set pref cartId : ", a)
                if(a) {
                    this.cartId = a;
                    resolve(this.cartId)
                }
                else {
                    this.cartId = globals.generateUUID();
                    this.storage.setPreference('cartId', this.cartId);
                    resolve(this.cartId)
                }

            }, (error)=>{

            }, () =>{
                // this.storeToLocal(data.payload,_payload)
            })

            // if(!this.cartId || this.cartId === null || this.cartId === undefined)
                // this.cartId = globals.generateUUID();
        })
    }

    getSetCartId() {
        return new Promise((resolve,reject)=>{
            this.storage.getPreference('cartId')
            .subscribe((a)=>{
                console.log("get pref cartId : ", a)
                if(a) {
                    this.cartId = a;
                    console.log("get pref cartId [a]: ", a)
                    resolve(a)

                }
                else if (!this.cartId || this.cartId === null || this.cartId === undefined) {
                    console.log("get pref cartId [null]: 1")
                    this.setCartId()
                    .then((result: any)=>{
                        if(result) {
                            console.log("get pref cartId [null]: ", result)
                            resolve(result)
                        }
                    });
                }
                else {
                    console.log("get pref cartId [else]: ")
                    this.setCartId()
                    .then((result: any)=>{
                        if(result) {
                            console.log("get pref cartId [else]: ", result);
                            resolve(result);
                        }
                    });
                }
            }, (error)=>{

            }, () =>{
            })
        })
    }
    getCartId() {
        let _cartId = '';
        this.getSetCartId()
        .then((result: any)=>{
            if(result) {
                this.cartId = result;
                return this.cartId;
            }
            else return this.cartId;
        })
        return this.cartId;


    }

    orderDetails: OrderExtended;
    setOrderDetails(orderDetails) {
        return new Promise((resolve, reject) => {
            this.storage.getPreference('orderDetails')
            .subscribe((a)=>{
                console.log("get/set pref orderDetails : ", a)
                if(a) {
                    this.orderDetails = a;
                    resolve(this.orderDetails)
                }
                else {
                    this.orderDetails = orderDetails;
                    this.storage.setPreference('orderDetails', this.orderDetails);
                    resolve(this.orderDetails)
                }

            }, (error)=>{

            }, () =>{
            })

        })
    }

    getOrderDetails() {
        return this.orderDetails;
    }

    clearLocalOrder() {
        this.storage.deletePreference('orderDetails');
        this.storage.deletePreference('orderId');
    }

    clearLocalCartId() {
        this.storage.deletePreference('cartId');
    }

    getNeedRefreshOrderDetails() {
      return this.needRefreshOrderDetails.asObservable();
    }

    setNeedRefreshOrderDetails(setRefresh: boolean) {
      this.needRefreshOrderDetails.next(setRefresh);
    }





}
